import { api } from './apiClient';
import { API_ENDPOINTS } from '@/config';

export interface FeedbackParams {
  candidateUId: string;
  starRating: number;
  description: string;
  type: string;
  uId: string | null;
}

export const feedbackService = {
  submitFeedback: async (
    params: FeedbackParams
  ): Promise<{ message: string }> => {
    return api.interviewAgent.post(
      API_ENDPOINTS.candidate.submitInterviewFeedback,
      params
    );
  },
};
